import { css } from '@emotion/css';
import { ColorConstant, Font, Spacing } from 'src/styles';

export const container = ({
  size,
  type,
}: {
  size: 'small' | 'medium' | 'large';
  type: 'info' | 'warning' | 'error';
}) => css`
  ${size === 'small' ? Font.md : size === 'medium' ? Font.lg : Font.h1}
  width: 100%;
  background-color: ${type === 'error'
    ? ColorConstant.RED1
    : type === 'warning'
    ? ColorConstant.ORANGE2
    : ColorConstant.BRAND1};
  min-height: 64px;
`;

export const col = css`
  border-top: 1px solid #ccdded;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.35);
`;

export const icon = ({ type }: { type: 'info' | 'warning' | 'error' }) => css`
  ${Font.h1}
  ${Spacing.mr4}
  color: ${type === 'error' ? ColorConstant.RED7 : type === 'warning' ? ColorConstant.ORANGE6 : ColorConstant.BRAND6};
`;
